import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { RowColor } from 'types';

type StyledTRProps = {
  colors?: RowColor;
};

const Body = styled.tbody`
  position: relative;
`;

const TR = styled.tr<StyledTRProps>`
  background-color: ${({ colors }) => pickColor(colors?.background || 'whiteBackground')};
  color: ${({ colors }) => pickColor(colors?.color || 'black')};
`;

const TD = styled.td`
  padding: 1.5rem;
`;

const NoData = styled.div`
  height: 10rem;
`;

const NoDataInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  min-height: 10rem;

  padding: 2rem 0;

  background-color: ${pickColor('white')};
`;

export { Body, TR, TD, NoData, NoDataInner };
